import { Container, Table } from 'react-bootstrap'
import Link from 'next/link'
import { Request } from '@group-devs/yfp7-global-modules'
import { useState, useEffect } from 'react'


const request = new Request(process.env.apiDomain)

const content1 = 
[
    {img:"/images/general/yfp-no-image.jpg", name:"Slaying the Food Myths", type:"Article", date:"Mar 15, 2015", point:"3", comment:"I really liked this webinar because." },
    {img:"/images/general/yfp-no-image.jpg", name:"The Healing Effect", type:"Video", date:"Mar 15, 2015", point:"2", comment:"Write a review and earn points" },
    {img:"/images/general/yfp-no-image.jpg", name:"Hungry for Change", type:"E-Book", date:"Mar 15, 2015", point:"2", comment:"Write a review and earn points" },

]

function convertTime(timestamp)
{
    let unix_timestamp = timestamp
    // Create a new JavaScript Date object based on the timestamp
    // multiplied by 1000 so that the argument is in milliseconds, not seconds.
    var date = new Date(unix_timestamp * 1000);

    var year = date.getFullYear();
    var day = date.getDay();
    var month = date.toLocaleString('default', { month: 'long' });

    // Will display time in 10:30:23 format
    return month + ' ' + day + ', ' +  year;

}

export default function ActivityContentReview(props) {

    let contactAccount = props.contactAccount

    const [contactId, setContactId] = useState(null);


    useEffect(() => {

        if(typeof contactAccount != 'undefined'){

            setContactId(contactAccount.contact_id)
        }
        
    }, [contactAccount]);

    let contents = [];

    const contact_id = 1;

    const currentYear = new Date().getFullYear(); //Current Year
    const year = currentYear - 1

    // Get monthly statistics
    const { data: contentData} = request.stats.contentViewed(contact_id);
    
    if(contentData){
        contents = JSON.parse(contentData.content);
    }
    
    return(
        <Container className="py-5">
            <h4 className="font-weight-bold py-2 mb-5">My Content Reviewed</h4>
            <Table striped responsive="sm" className="table-hover">
                <thead>
                <tr>
                    <th>Content</th>
                    <th>Type</th>
                    <th>Date Viewed</th>
                    <th>Points</th>
                    <th>Comment</th>
                </tr>
                </thead>
                <tbody>
                    {
                        contentData ? 

                            Object.keys(contents).map((data, index) => (
                                <tr key={index}>
                                    <td><img src={contents[data].content.thumbnail != null ? process.env.imageHostingDomain+'/'+contents[data].content.thumbnail : (contents[data].content.thumbnail == null || contents[data].content.thumbnail == "" ? process.env.imageHostingDomain+'/'+contents[data].content.feature_img : '/images/general/yfp-no-image.jpg') }/> {contents[data].content.title}</td>
                                    <td>{contents[data].content.type}</td>
                                    <td>{convertTime(contents[data].created_at)}</td>
                                    <td>{contents[data].earned_point}</td>
                                    <td>{contents[data].misc}</td>
                                </tr>
                            ))

                        : ''
                    }
                </tbody>
            </Table>
            <style jsx global>
                {  `
                    
                    .table-hover>tbody>tr:hover{
                        background-color: rgb(67 166 73 / 21%);
                    }
                    
                    table th{
                        background-color:#43a649;
                        color:#fff;
                        border:0;
                    }
                    .table td, .table th{
                        border: 0!important;
                        vertical-align: middle;
                        padding: .85rem .75rem;
                    }
                    .table-striped tbody tr:nth-of-type(odd) {
                        background-color: transparent;
                    }
                    .table-striped tbody tr:nth-of-type(even) {
                        background-color: rgba(0,0,0,.05);
                    }

                    .table td img{
                        max-width: 90px;
                        margin-right: 1rem;
                    }
                `}
            </style>
        </Container>

    )
};
